import React from 'react';

const METRIC_KEYS = [
  { key: 'jawlineAngleSymmetry', label: 'Jawline Angle Symmetry' },
  { key: 'jawlineAngleLeft', label: 'Jawline Angle Left' },
  { key: 'jawlineAngleRight', label: 'Jawline Angle Right' },
  { key: 'facialHarmonyScore', label: 'Facial Harmony Score' },
  { key: 'facialThirdsBalance', label: 'Facial Thirds Balance' },
  { key: 'goldenRatioProportions', label: 'Golden Ratio Proportions' },
  { key: 'cheekProjectionSymmetry', label: 'Cheek Projection Symmetry' },
];

function getMetricValue(metrics, key) {
  if (!metrics) return null;
  const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
  return metrics[key] ?? metrics[snakeKey] ?? null;
}

function formatValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'number') return Number.isInteger(value) ? value : value.toFixed(1);
  return value;
}

function SymmetryMetricsTable({ symmetryMetrics }) {
  const before = symmetryMetrics?.before || {};
  const after = symmetryMetrics?.after || {};

  return (
    <div className="aesthetic-section">
      <h2 className="aesthetic-section-title">Jawline Analytics</h2>
      <div style={{ overflowX: 'auto' }}>
        <table className="symmetry-metrics-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Before</th>
              <th>After</th>
            </tr>
          </thead>
          <tbody>
            {METRIC_KEYS.map(({ key, label }) => (
              <tr key={key}>
                <td className="metric-name">{label}</td>
                <td className="metric-value">{formatValue(getMetricValue(before, key))}</td>
                <td className="metric-value">{formatValue(getMetricValue(after, key))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SymmetryMetricsTable;
